




import { Component, Vue, Prop } from "vue-property-decorator";
import { Message } from "@/api/message-api";
import ProjectMember from "@/models/project-member";
import autoLink from "@/helpers/message-helper";
import formatTime from "../helpers/formatTime";
import ChatMessage, {
  ChatMessageProps
} from "../components/chat/ChatMessage.vue";

@Component({
  components: {
    ChatMessage
  }
})
export default class VChatMessage extends Vue {
  @Prop({ required: true }) protected message!: Message;
  @Prop({ type: Boolean }) toMe!: boolean;

  get chatMessage(): ChatMessageProps {
    return {
      sender: {
        group: this.from.group,
        name: this.from.name,
        icon: {
          src: this.from.icon
        }
      },
      receivers: this.to.map(receiver => ({
        name: receiver.staff ? `${receiver.staff.name}さん` : "名無しさん",
        variant: this.toMe ? "primary" : "secondary"
      })),
      body: this.htmlMessage,
      // TODO: anyやめる
      image: (this.message as any).imageURL,
      postedAt: formatTime(this.message.created)
    };
  }

  get htmlMessage(): string {
    return autoLink(this.message.body);
  }

  get to() {
    // APIでtoやその中身がundefinedになることがある
    return this.message.to || [];
  }

  get from(): { group: string; name: string; icon: string } {
    const m = this.message.from;
    return {
      group: this.getGroupName(m),
      name: this.getNameOfProjectMember(m),
      icon: m.user ? m.user.icon.imageURL : "https://fakeimg.pl/50x50/"
    };
  }

  getGroupName(m: ProjectMember): string {
    const s = m.staff;
    if (s && s.company && s.office) {
      return `${s.company.name} ${s.office.name}`;
    }
    return "";
  }

  getNameOfProjectMember(m: ProjectMember): string {
    if (m.staff) return m.staff.name;
    if (m.user) return m.user.name;
    return "unknown";
  }
}
